
import { defineComponent } from "vue";
import HomeTopics from "@/components/Home/HomeEvents.vue";
import Header from "@/components/Header.vue";
import BaseImage from "@/components/BaseImage.vue";

export default defineComponent({
  name: "Home",
  components: {
    BaseImage,
    Header,
    HomeTopics,
  },
  data(): { title: string; content: string } {
    return {
      title: "About me",
      // language=HTML
      content: `
      I'm an AI & ML data scientist from Singapore</br>
      Enjoying programming & 3D art on the side.</br>
      `,
    };
  },
});
